<template>
  <span>
    <v-app-bar app color="black" dark>
      <v-app-bar-nav-icon class="hidden-lg-and-up" @click="drawer = !drawer" />
      <v-toolbar-title>Administrace</v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-menu offset-y origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-row align="center" justify="center" class="pa-0">
              <v-col class="pr-1">
                <v-btn
                  v-if="user && user.messageCount"
                  icon
                  text
                  :to="{
                    name: 'notifications',
                  }"
                >
                  <v-badge
                    v-if="user && user.messageCount"
                    bordered
                    overlap
                    :content="user.messageCount"
                  >
                    <v-icon dark size="28"> mdi-bell </v-icon>
                  </v-badge>
                </v-btn>
                <v-btn v-else icon text>
                  <v-icon dark size="28"> mdi-bell </v-icon>
                </v-btn>
              </v-col>
              <v-col class="pl-1">
                <v-btn slot="activator" icon text v-on="on">
                  <v-icon dark size="30"> mdi-account-circle </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <v-list dense nav>
            <v-list-item v-if="user">
              <v-list-item-content class="text-right">
                <strong>{{ user.email }}</strong>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
            <v-list-item
              v-for="(item, index) in menuProfile"
              :key="index"
              :to="!item.href ? { name: item.name } : null"
              :href="item.href"
              :disabled="item.disabled"
              :target="item.target"
              @click="logoutAndRedirect"
            >
              <v-list-item-action v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
    <v-toolbar color="transparent" flat class="mt-4">
      <TheBreadcrumbs />
    </v-toolbar>
    <v-navigation-drawer v-model="drawer" app>
      <v-app-bar color="black">
        <v-img contain src="@/assets/logo_horizontal.svg" height="35"></v-img>
      </v-app-bar>
      <v-list dense nav>
        <v-list-item
          v-for="(item, index) in menuByRole"
          :key="index"
          :to="{ name: item.name }"
          :exact="item.exact"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> {{ item.title }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider class="ml-2 mr-2"></v-divider>
      <v-list dense nav>
        <v-list-item
          v-for="(item, index) in promoMenuByRole"
          :key="index"
          :to="{ name: item.name }"
          :exact="item.exact"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> {{ item.title }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider class="ml-2 mr-2"></v-divider>
      <v-list dense nav>
        <v-list-item
          v-for="(item, index) in toolMenuByRole"
          :key="index"
          :to="{ name: item.name }"
          :exact="item.exact"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> {{ item.title }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider class="ml-2 mr-2"></v-divider>
      <v-list dense nav>
        <v-list-item
          v-for="(item, index) in settingMenuByRole"
          :key="index"
          :to="{ name: item.name }"
          :exact="item.exact"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> {{ item.title }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-0">
          <DataSyncInfo />
        </div>
      </template>
    </v-navigation-drawer>
  </span>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TheBreadcrumbs from '@/components/TheBreadcrumbs'
import DataSyncInfo from './product/DataSyncInfo'

export default {
  name: 'AppNavigation',
  components: { DataSyncInfo, TheBreadcrumbs },
  data: () => ({
    drawer: true,
    menu: [
      {
        title: 'Zákazníci',
        name: 'customers',
        icon: 'mdi-account-supervisor',
        exact: false,
        roles: ['ROLE_ADMIN'],
      },
      {
        title: 'Objednávky',
        name: 'orders',
        icon: 'mdi-view-list',
        exact: false,
        roles: ['ROLE_ADMIN'],
      },
      {
        title: 'Dodavatelé a produkty',
        name: 'suppliers',
        icon: 'mdi-view-list',
        exact: false,
        roles: ['ROLE_ADMIN'],
      },
      {
        title: 'Personalizované nabídky',
        name: 'personalized-offer',
        icon: 'mdi-view-list',
        exact: false,
        roles: ['ROLE_ADMIN'],
      },
      {
        title: 'Zprávy a upozornění',
        name: 'messages',
        icon: 'mdi-message-text',
        exact: false,
        roles: ['ROLE_ADMIN'],
      },
    ],
    menuPromo: [
      {
        title: 'Propagace',
        name: 'promotions',
        icon: 'mdi-bullhorn',
        exact: false,
        roles: ['ROLE_ADMIN'],
      },
      {
        title: 'Dárky a promo kódy',
        name: 'gifts',
        icon: 'mdi-gift',
        exact: false,
        roles: ['ROLE_ADMIN'],
      },
    ],
    menuTools: [
      {
        title: 'Kalkulačka elektřina',
        name: 'electricity-calculator',
        icon: 'mdi-calculator',
        exact: false,
        roles: ['ROLE_ADMIN'],
      },
      {
        title: 'Kalkulačka plyn',
        name: 'gas-calculator',
        icon: 'mdi-calculator',
        exact: false,
        roles: ['ROLE_ADMIN'],
      },
    ],
    menuSettings: [
      {
        title: 'Uživatelé',
        name: 'users',
        icon: 'mdi-account-supervisor',
        exact: false,
        roles: ['ROLE_ADMIN'],
      },
      {
        title: 'Administrátoři',
        name: 'administrators',
        icon: 'mdi-account-supervisor',
        exact: false,
        roles: ['ROLE_ADMIN'],
      },
    ],
    menuProfile: [
      {
        title: 'Odhlásit se',
        icon: 'mdi-power',
        href: '#',
      },
    ],
    user: null,
    timer: null,
    loading: true,
  }),
  computed: {
    ...mapState({
      userName: (state) => (state.auth.user ? state.auth.user.user_name : ''),
      userRoleName: (state) => (state.auth.user ? state.auth.user.role_name : ''),
      authorities: (state) => (state.auth.user ? state.auth.user.authorities : ''),
    }),
    menuByRole() {
      return this.menu.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
    promoMenuByRole() {
      return this.menuPromo.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
    toolMenuByRole() {
      return this.menuTools.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
    settingMenuByRole() {
      return this.menuSettings.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  created() {
    this.drawer = this.$vuetify.breakpoint.lgAndUp
    this.loadUser()
    this.setupRefreshInterval()
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    ...mapActions({
      getMe: 'auth/me',
      logout: 'auth/logout',
    }),
    loadUser() {
      this.loading = true
      this.getMe()
        .then((response) => {
          this.user = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    logoutAndRedirect() {
      this.logout().catch(() => {
        // Hack for guard route
        this.$router.push({
          name: 'login',
        })
      })
    },
    setupRefreshInterval() {
      this.timer = setInterval(this.loadUser, 5000)
    },
  },
}
</script>

<style lang="scss">
.v-list-item {
  color: #fff;
}
</style>
